module.exports = __webpack_public_path__ + "static/media/7Anniversary.c31e7edb.png";